export default {
  'menu.welcome': '환영합니다',
  'menu.entity': '엔터티',
  'menu.more-blocks': 'More Blocks',
  'menu.home': '홈',
  'menu.admin': '관리자',
  'menu.admin.sub-page': '하위 페이지',
  'menu.login': '로그인',
  'menu.register': '회원가입',
  'menu.register-result': '가입 결과',
  'menu.dashboard': '대시보드',
  'menu.dashboard.analysis': '앱',
  'menu.dashboard.monitor': '모니터',
  'menu.flow': '플로우',
  'menu.divider': '구분선',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': '프로필',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': '성공',
  'menu.result.fail': '실패',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': '계정',
  'menu.account.center': '계정 센터',
  'menu.account.settings': '계정 설정',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': '로그아웃',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.user-management': '사용자',
  'menu.tag-management': '태그',
  'menu.canned-response': '정형 답변',
  'menu.chatrooms': '채팅방',
  'menu.email': '이메일',
  'menu.core': '핵심 기능',
  'menu.files': '파일',
  'menu.filesNew': '파일 (신규)',
  'menu.filesRefactored': '파일 (개선)',
  'menu.favouritesHub': '매터',
  'menu.library': '프롬프트 라이브러리',
  'menu.chat': '채팅',
  'menu.search': '검색',
  'menu.specialised': '전문 기능',
  'menu.app': '앱',
  'menu.playbook': 'Workstudio',
  'menu.template': '맞춤 출력',
  'menu.quote': '견적',
  'menu.review': '검토',
  'menu.sideBySide': '나란히 보기',
  'menu.grading': '평가',
  'menu.setting': '설정',
  'menu.diagnostics': '진단',
  'menu.context': '컨텍스트',
  'menu.management': '관리',
  'menu.conversation': '대화',
  'menu.translation': '번역',
  'menu.broadcast': '공지',
  'menu.dictionary': '사전',
  'menu.question': '질문',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': '새 플로우',
  'menu.form.update-flow': '플로우 수정',
  'menu.list.flow-list': '플로우 목록',
  'menu.comparison': '비교',
  'menu.scribe': '스크라이브',
  'menu.organisation': '조직',
  'menu.superAdminOrganisation': '슈퍼 관리자 조직',
  'menu.section.vault': '보관함',
  'menu.section.chatAndCompose': '채팅 및 작성',
  'menu.section.specialised': '전문 기능',
  'menu.section.system': '시스템',
};
